import { Action, ActionReducer, createFeature } from '@ngrx/store';
import {
    LotFetchedSuccessfulAction,
    LotFetchedSuccessfulActionProps,
    SelectedLotServiceActions,
    SelectedLotUIActions,
} from './selected-lot.actions';
import { AuctionLotDetail } from '@viewbid/ts-angular-client';

export const selectedLotFeatureKey: string = 'selectedLot';

export interface SelectedLotState {
    result: AuctionLotDetail | null | Error;
    isLoading: boolean;
    hasError: boolean;
    errorCode: number | undefined;
}

export const initialState: SelectedLotState = {
    result: null,
    isLoading: false,
    hasError: false,
    errorCode: undefined,
};

export const selectedLotStateReducer: ActionReducer<
    SelectedLotState,
    Action
> = (
    state: SelectedLotState = initialState,
    action: Action,
): SelectedLotState => {
    switch (action.type) {
        case SelectedLotUIActions.SelectLotAction: {
            const newState: SelectedLotState = { ...state };
            newState.isLoading = true;
            newState.hasError = false;
            newState.result = null;
            newState.errorCode = undefined;
            return newState;
        }
        case SelectedLotServiceActions.LotFetchedSuccessfulAction: {
            const lotFetchedSuccessfulAction: LotFetchedSuccessfulAction =
                action as LotFetchedSuccessfulAction;
            const props: LotFetchedSuccessfulActionProps =
                lotFetchedSuccessfulAction.props;
            const newState: SelectedLotState = { ...state };
            newState.isLoading = false;
            newState.hasError = false;
            newState.result = props.result;
            newState.errorCode = undefined;
            return newState;
        }
        case SelectedLotServiceActions.LotFetchedFailedAction: {
            const newState: SelectedLotState = { ...state };
            newState.isLoading = false;
            newState.result = new Error('unable to load lot');
            newState.hasError = true;
            const failedAction: any = action as any;
            if (failedAction.props.errorCode) {
                newState.errorCode = failedAction?.props?.errorCode;
            }
            return newState;
        }
        default:
            return state;
    }
};

// eslint-disable-next-line
export const selectedLotFeature = createFeature({
    name: selectedLotFeatureKey,
    reducer: selectedLotStateReducer,
});
